import client from './client';
import type {
  Monitor,
  MetricData,
  Alert,
  ServiceObservability,
  PaginatedResponse,
} from '@/types';

export interface MonitorListParams {
  service_id?: string;
  status?: string;
  page?: number;
  page_size?: number;
}

export interface AlertListParams {
  service_id?: string;
  status?: string;
  page?: number;
  page_size?: number;
}

export async function fetchMonitors(params?: MonitorListParams) {
  const { data } = await client.get<PaginatedResponse<Monitor>>('/observability/monitors', { params });
  return data;
}

export async function fetchMonitor(id: string) {
  const { data } = await client.get<Monitor>(`/observability/monitors/${id}`);
  return data;
}

export async function fetchServiceMetrics(
  serviceSlug: string,
  metrics?: string,
  periodStart?: string,
  periodEnd?: string,
) {
  const { data } = await client.get<Record<string, MetricData>>(
    `/observability/metrics/${serviceSlug}`,
    {
      params: {
        metrics,
        period_start: periodStart,
        period_end: periodEnd,
      },
    },
  );
  return data;
}

export async function fetchAlerts(params?: AlertListParams) {
  const { data } = await client.get<PaginatedResponse<Alert>>('/observability/alerts', { params });
  return data;
}

export async function fetchServiceObservability(serviceSlug: string) {
  const { data } = await client.get<ServiceObservability>(
    `/observability/dashboard/${serviceSlug}`,
  );
  return data;
}
